import type { FaireProductEntity } from "../../entity_types/product";

export const p_4o6j39huoz: FaireProductEntity = {
  token: "p_4o6j39huoz",
  type: "product",
  name: "Eclipse Necklace",
  brandToken: "b_ctpxrpayah",
  brandName: "Ker-ij Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/bde3b2974853dbdfcdf34ed7ebe194a146dd37c228d1b374dcbb65da38e1be68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6840ec406e0aa76e0042787bec0a226e5d25ec458e793516d9673ec53f4ddb8.jpeg",
    "https://cdn.faire.com/fastly/7918625c79dc8c4dde1f9fa7310623c5ef4c588f82c4968882155db81ec18316.jpeg",
    "https://cdn.faire.com/fastly/a0fa1615a722f7d390c73a7de4a6e5305259707b1d45dc8a49dbd10bf3b4d831.jpeg",
    "https://cdn.faire.com/fastly/fde85edfc36cabb74b8d486f81bdcb1acbf96c188926edc130eb315c0eecaa32.jpeg",
    "https://cdn.faire.com/fastly/ee6ff6ceb916f5ae5131286ca61ad75d42938863c9a07394824f6b187857e969.jpeg",
    "https://cdn.faire.com/fastly/d55669f268ca06420711c35bf25417084592838a8a59c148d0c772b4991088b0.jpeg",
    "https://cdn.faire.com/fastly/3ae057f86cddfef64ea9555720072ef725d3c80d96a41a1004f53d5600e39841.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/310dfed1038397a817d6710e7653df9148e695eaffe8a20cd73e34b33f07a9a9/1556569150.jpg",
    "https://cdn.faire.com/fastly/b0192b857cd45697c3f73285342297dabf34095f00e8827c6c71cf92565bd6a8.jpeg",
  ],
  priceDollars: 19,
  description:
    'Meet your new wear-it-on-repeat piece. These Eclipse gemstone necklaces feature smooth gemstone beads cradled in a sleek raw brass crescent—simple, minimal, and full of quiet charm.\nStrung on a dainty 16–18" snake chain, they’re perfect for layering or adding just a hint of shine to your everyday look. Effortless, versatile, and a little celestial—you’ll wonder how you ever got dressed without one.\n\nChoose from Dalmatian Jasper, Red Jasper, Green Aventurine, Olive Jade, Lapis or Moonstone.',
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:24.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
